import { useQuery } from "@tanstack/react-query";

import { shellBootstrapQuery } from "./bootstrap";
import { NavigationCards } from "./NavigationCards";
import type { ShellServices } from "./services";
import { EmptyState } from "./states";
import { userSectionsNavigation } from "./workspaceNavigation";

/** Вход в раздел «Пользователи»: карточки сотрудников и дерево иерархии. */
export function UsersOverviewPage({ services }: { services: ShellServices }) {
  const bootstrap = useQuery(shellBootstrapQuery(services));
  const items =
    bootstrap.data === undefined
      ? []
      : userSectionsNavigation(bootstrap.data.permissions);

  return (
    <section className="workspace-page" aria-labelledby="users-overview-title">
      <div className="page-heading">
        <p className="eyebrow">Администрирование</p>
        <h1 id="users-overview-title">Пользователи</h1>
        <p>
          Карточки сотрудников с доступом и безопасностью, а также иерархия
          сотрудников.
        </p>
      </div>
      <NavigationCards items={items} />
      {items.length === 0 ? (
        <EmptyState
          title="Нет доступных разделов"
          description="Для работы с пользователями нужны дополнительные права."
        />
      ) : null}
    </section>
  );
}
